export default __webpack_public_path__ + "static/media/bank-transfer.c68b070c.svg";